export const UPDATE_ALUNOS_LIVROS = 'UPDATE_ALUNOS_LIVROS'
export const ADD_ALUNOS_LIVROS = 'ADD_ALUNOS_LIVROS'
export const SET_ALUNOS_LIVROS = 'SET_ALUNOS_LIVROS'
export const REMOVE_ALUNOS_LIVROS = 'REMOVE_ALUNOS_LIVROS'
export const SET_ALUNO_LIVRO = 'SET_ALUNO_LIVRO'
export const OPEN_ALUNO_LIVRO = 'OPEN_ALUNO_LIVRO'
export const CLOSE_ALUNO_LIVRO = 'CLOSE_ALUNO_LIVRO'